import { useDispatch } from '@redux';
import crudActions from '@redux/crudActions';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FailQCModal from '../components/Modal/FailQCModal';
import PassQCModal from '../components/Modal/PassQCModal';

const QAQCCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleFailQC = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['failQC']: {
          isOpen: value,
        },
      } as any),
    );
  };
  const handlePassQC = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['passQC']: {
          isOpen: value,
        },
      } as any),
    );
  };

  return (
    <div className="flex gap-5 w-full">
      <Button className="w-full h-[40px]" onClick={() => handleFailQC(true)}>
        {t('button.failQC')}
      </Button>
      <Button
        type="primary"
        className="w-full h-[40px]"
        onClick={() => handlePassQC(true)}
      >
        {t('button.passQC')}
      </Button>
      <FailQCModal onCancel={() => handleFailQC(false)} />
      <PassQCModal onCancel={() => handlePassQC(false)} />
    </div>
  );
};

export default QAQCCard;
